import api from './api';

export async function uploadMedia({
  file,
  kind,
  scope,
  slug,
  previousUrl,
}) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('kind', kind);
  formData.append('scope', scope);

  if (slug) {
    formData.append('slug', slug);
  }

  if (previousUrl) {
    formData.append('previousUrl', previousUrl);
  }

  const response = await api.post('/uploads', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
}

export async function uploadWhitePaperDocument({
  file,
  slug,
  previousUrl,
}) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('slug', slug);

  if (previousUrl) {
    formData.append('previousUrl', previousUrl);
  }

  const response = await api.post('/whitepapers/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
}

